<template>
  <pagination
    v-if="pagesCount > 1"
    :name="name"
    :show-page-buttons="showPageButtons"
    :pages-count="pagesCount"
    :page="currentPage"
    placeholder-element="products-list-pagination"
    @change="onPagerChange"
  />
</template>

<script lang="ts">
  import {defineComponent, computed, onMounted} from 'vue';
  import * as scrollToElement from 'scroll-to-element';
  import productListStore from '../../stores/product/ProductListStore';
  import productListService, {ProductsListService} from '../../services/productsList/ProductsListService';

  export default defineComponent({
    name: 'ProductListPagination',

    props: {
      name: {
        type: String,
        default: ''
      },
      showPageButtons: {
        type: Boolean,
        default: true
      },
      scrollToElement: {
        type: String,
        default: ''
      },
      offsetTop: {
        type: Number,
        default: 0
      }
    },

    setup(props) {
      const pagesCount = computed(() => productListStore.pagingData.pagesCount);
      const currentPage = computed(() => productListStore.pagingData.currentPage);

      const onPagerChange = (page: number) => {
        const param = {};
        param[ProductsListService.pageParameterName] = [page - 1];
        productListService.changeParameters(param);

        scrollToElement(props.scrollToElement, {
          offset: props.offsetTop,
          duration: 500
        });
      };

      return {
        productListStore,
        pagesCount,
        currentPage,
        onPagerChange
      }
    },
  });
</script>
